import React, { useState } from "react";
import ProjectDesignDocumentsAllTabCard from "./ProjectDesignDocumentsAllTabCard";
// import { PDDAllProjects } from "./PDDAllProjectsList";
import { useUserRoleSelector } from "../../../../../store/users/selectors";
import { UserRoles } from "../../../../../types";
import { useSearchParams } from "react-router-dom";
import { NoData } from "../../../../../components/NoData";
import { useQuery } from "@tanstack/react-query";
import Pagination from "../../../../../components/Pagination";
import { fetchPDD } from "../../../services";

const renderSkeleton = () => {
  return (
    <div className="animate-pulse cursor-pointer space-y-3 rounded-md bg-white px-4 py-2 shadow-sm">
      <div className="flex items-start gap-4">
        <div className="h-6 flex-1 rounded bg-gray-200"></div>
        <div className="h-6 w-6 rounded bg-gray-200"></div>
      </div>
      <div className="relative">
        <div className="h-32 rounded-sm bg-gray-200"></div>
      </div>
      <div className="flex justify-between">
        <div>
          <div className="h-4 w-20 rounded bg-gray-200"></div>
          <div className="mt-1 h-4 w-32 rounded bg-gray-200"></div>
        </div>
        <div>
          <div className="h-4 w-20 rounded bg-gray-200"></div>
          <div className="mt-1 h-4 w-24 rounded bg-gray-200"></div>
        </div>
      </div>
    </div>
  );
};

const ProjectDesignDocumentsTabsAllTab = () => {
  const userRole = useUserRoleSelector();
  const [searchParams] = useSearchParams();
  const pddStatus = searchParams.get("tab");
  const [page, setPage] = useState<number>(1);

  const { data: allPDDDocuments, isFetching } = useQuery({
    queryKey: ["allPDDDocuments", pddStatus, page],
    initialData: { data: [], limit: 24, skip: 0, total: 0 },
    queryFn: () => fetchPDD(page, 24, pddStatus),
  });

  return (
    <div>
      <div className="grid grid-cols-3 gap-4">
        {isFetching ? (
          renderSkeleton()
        ) : allPDDDocuments.data.length === 0 ? (
          <NoData />
        ) : (
          allPDDDocuments.data.map((pddDocumentData, index) => (
            <ProjectDesignDocumentsAllTabCard
              projectDetails={pddDocumentData}
              downloadable={userRole === UserRoles.ADMIN_APPROVER}
              key={index}
            />
          ))
        )}
      </div>
      <div className="mt-6 flex justify-center">
        <Pagination
          page={page}
          totalItems={allPDDDocuments.total}
          itemsPerPage={allPDDDocuments.limit}
          onPageChange={setPage}
        />
      </div>
    </div>
  );
};

export default ProjectDesignDocumentsTabsAllTab;
